import React, { useState, useEffect } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";
import validations from "../../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";

const EditModel = () => {
  const [formData, setFormData] = useState({});
  const [productOptions, setProductOptions] = useState([]);
  const [subProductOptions, setSubProductOptions] = useState([]);
  const [makeOptions, setMakeOptions] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const location = useLocation();
  const { data } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = data?.business_partner_id;
  const [colorOptions, setColorOptions] = useState([]);

  useEffect(() => {
    fetchModelProduct();
  }, []);
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axiosInstance.post(
          "/product/ddlproduct",
          {
            orderBy: "product_id desc",
            page: 0,
            pageSize: 1000,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          },
        );

        const productList = response.data.data.data.map((product) => ({
          label: product.NAME,
          value: product.ID,
        }));

        setProductOptions(productList);
      } catch (error) {
        console.error("Error fetching product list:", error);
      }
    };

    fetchProducts();
  }, []);

  // useEffect(() => {
  //   const fetchSubproducts = async () => {
  //     if (!formData.productName) return;

  //     console.log('Fetching subproducts for product ID:', formData.productName.value);

  //     try {
  //       const response = await axiosInstance.post('/subproduct/ddlsubproduct', {
  //         product_id: formData.productName,
  //         orderBy: 'subproduct_id desc',
  //         page: 0,
  //         pageSize: 1000
  //       }, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         }
  //       });

  //       const subproductList = response.data.data.data.map(subproduct => ({
  //         label: subproduct.NAME,
  //         value: subproduct.ID
  //       }));

  //       setSubProductOptions(subproductList);
  //     } catch (error) {
  //       console.error('Error fetching subproduct list:', error);
  //     }
  //   };

  //   fetchSubproducts();
  // }, [formData.productName]);

  useEffect(() => {
    const fetchMakes = async () => {
      if (!formData.subproductName) return;

      console.log(
        "Fetching makes for subproduct ID:",
        formData.subproductName.value,
      );

      try {
        const response = await axiosInstance.post(
          "/make/ddlmake",
          {
            subproduct_id: formData.subproductName.value,
            orderBy: "make_id desc",
            page: 0,
            pageSize: 1000,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          },
        );

        const makeList = response.data.data.data.map((make) => ({
          label: make.NAME,
          value: make.ID,
        }));

        setMakeOptions(makeList);
      } catch (error) {
        console.error("Error fetching make list:", error);
      }
    };

    fetchMakes();
  }, [formData.subproductName, authToken]);

  // useEffect(() => {
  //   if (data) {
  //     console.log("modeldata>>>",data);
  //     setFormData({
  //       productName: { label: data.product_name, value: data.product_id },
  //       subproductName: { label: data.subproduct_name, value: data.subproduct_id },
  //       makeName: { label: data.make_name, value: data.make_id },
  //       modelName: data.model_name,
  //       modelDesc: data.model_desc,
  //       status: { label: data.status, value: data.status },
  //     });
  //   }
  // }, [data]);

  useEffect(() => {
    fetchColorOptions();
  }, []);

  const fetchColorOptions = async () => {
    try {
      const payload = {};
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post("/color/ddlcolor", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error("Error fetching color options:", error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    formConfig.forEach((field) => {
      if (field.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      }
      if (
        field.validation?.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    try {
      setLoading(true);

      const payload = {
        product_id: formData.productName,
        subproduct_id: formData.subproductName,
        // make_id: formData.makeName,
        model_name: formData.modelName,
        model_desc: formData.modelDesc,
        colour_id_list: formData.colour_id_list,
        status: formData.status === true ? 1 : 0, // Assuming status is a string like 'Active' or 'Inactive'
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      // Show confirmation dialog using reusable alert
      const confirmation = await showAlert({
        title: "Confirmation",
        text: "Are you sure you want to update this record in Model?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      });

      // If the user cancels, exit early
      if (!confirmation.isConfirmed) {
        setLoading(false);
        return;
      }

      try {
        // API request to update the model
        const response = await axiosInstance.patch(
          `/model/update/${data.model_id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          },
        );

        console.log("API Response:", response.data);

        // Show success alert after API response using reusable alert
        await showAlert({
          title: "Success",
          text: "Model updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });

        // Navigate after success
        navigate("/admin/manage-product/model");
      } catch (error) {
        console.error("Error submitting form:", error);

        // Show error alert using reusable alert
        const errorMessage =
          error.response?.data?.message ||
          "Failed to update model. Please try again.";
        showAlert({
          title: "Error",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error during form submission:", error);
    }
  };

  const fetchModelProduct = async () => {
    try {
      const response = await axiosInstance.get(`/model/edit/${data.model_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const fetchedData = response.data.data;

      // Update formData with fetched data
      setFormData({
        business_partner_id: fetchedData.business_partner_id,
        productName: fetchedData.product_id,
        subproductName: fetchedData.subproduct_id,
        colour_id_list: fetchedData.color_id,
        // makeName:fetchedData.make_id,
        modelName: fetchedData.model_name,
        modelDesc: fetchedData.model_desc,
        status: fetchedData.status === 1 ? true : false,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const formConfig = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: validations.businessPartnerId({ required: true }),
          },
        ]
      : []),
    {
      name: "productName",
      label: "Product",
      type: "dropdown",
      required: true,
      options: productOptions,
      gridClass: "col-lg-4",
      onChange: (value, setFormData) => {
        console.log("Product selected:", value);
        setFormData((prevFormData) => ({
          ...prevFormData,
          productName: value,
          subproductName: null,
          makeName: null,
        }));
      },
    },
    // {
    //   name: "subproductName",
    //   label: "Subproduct",
    //   type: "dropdown",
    //   options: subProductOptions,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   onChange: (value, setFormData) => {
    //     console.log('Subproduct selected:', value);
    //     setFormData(prevFormData => ({
    //       ...prevFormData,
    //       subproductName: value,
    //       makeName: null,
    //     }));
    //   },
    // },
    // {
    //   name: "makeName",
    //   label: "Make",
    //   type: "dropdown",
    //   options: makeOptions,
    //   required: true,
    //   gridClass: "col-lg-4",
    // },
    {
      name: "modelName",
      label: "Model",
      placeholder: "Enter Model Name",
      type: "text",
      required: true,
      validation: validations.model({ required: true }),
      gridClass: "col-lg-4",
      disabled: true,
    },
    {
      name: "modelDesc",
      label: "Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.description({ required: true }),
    },
    {
      name: "colour_id_list",
      label: "Color Name",
      type: "multiselectdropdownStockin",
      options: colorOptions,
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",

      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Edit Model</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Edit Model Details
              </span>
              <DynamicForm
                validateOnMount
                formConfig={formConfig}
                formData={formData}
                setFormData={setFormData}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(formConfig, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  formConfig,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => handleFormSubmit(formData)}
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditModel;
